import * as React from "react";
import { connect } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { fetchOrden } from '../../actions/ordenesActions';
import { fetchMotivosRevision } from "../../actions/publicacionesActions";
import { getLogoPlataformaById } from "../../helper/ordenHelper";
import { limpiarFiltros } from '../../actions/generalActios';
import DatosComprador from "./DatosComprador";
import BigSpinner from "../General/BigSpinner";
import Estados from "./Estados/EstadosOrden";
import MedioDePago from "./MedioDePago";
import Productos from "./Productos";
import Entrega from "./Entrega";
import Comprobantes from "./Comprobantes";
import Tab from '../General/Tab';
import GoBackArrow from "../General/GoBackArrow";
import PropTypes from 'prop-types';

// Wrapper para usar hooks en class component
function OrdenEditWrapper(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    return <OrdenEdit {...props} navigate={navigate} id={id} location={location} />;
}



class OrdenEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            tabs: [
                { name: "Datos comprador", content: <DatosComprador idOrden={this.props.id} newOrden={false} /> },
                { name: "Productos", content: <Productos newOrden={false} /> },
                { name: "Entrega", content: <Entrega /> },
                { name: "Medio de pago", content: <MedioDePago newOrden={false} /> },
                { name: "Estados", content: <Estados history={this.props.history} /> },
                { name: "Comprobantes", content: <Comprobantes /> }
            ]
        }
    }

    componentDidMount() {
        this.props.fetchOrden(this.props.id, this.props.userId);
        this.props.fetchMotivosRevision();
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }


    return = () => {
        if (this.props.emptyFiltro.ordenes === false) {
            this.props.limpiarFiltros({
                publicaciones: true,
                ordenes: false,
                sellers: true,
                showFiltro: false,
                showFiltroOrdenes: true
            })
        }

        const pathReturn = this.props.location.state || "/Ordenes";
        this.props.navigate(`${pathReturn}`);
    }


    render() {
        let numeroOrden = this.props.id;
        let orden = JSON.stringify(this.props.orden);
        let idVendedorBoca = null;
        let imgLogo = null;

        if (orden != undefined) {
            if (orden != "{}") {
                idVendedorBoca = this.props.orden.idVendedorBoca;
                imgLogo =
                    <img
                        alt="icon_mega"
                        style={{ position: "absolute", top: "10px", right: "20px", width: "50px" }}
                        src={this.props.orden?.seller?.urlLogo != ""
                            ? this.props.orden.seller.urlLogo
                            : getLogoPlataformaById(this.props.orden.plataforma.codigo)
                        }
                    />
            }
        }


        return (
            <div className="col-sm-12">
                {this.props.loadingOrdenes ? <BigSpinner message="Cargando detalle de la orden..." /> :
                    <div className="card">

                        {this.props.userType.isAdminMod && imgLogo}

                        {this.props.userType.isAdminMod &&
                            <label style={{ fontWeight: "bold", position: "absolute", top: "70px", right: "23px" }}>
                                {idVendedorBoca == 0 ? "" : idVendedorBoca}
                            </label>
                        }
                        <div className="card-body">
                            <div className="col-12 mt-4">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <GoBackArrow />
                                        <h4 className="card-title">Orden - {numeroOrden}</h4>
                                    </div>
                                </div>
                            </div>
                            <ul className="nav nav-tabs customtab">
                                {
                                    this.state.tabs.map((tab, index) => {
                                        return <button type="button" style={{ border: "none", background: "none" }} key={tab.name} onClick={() => { this.onChangeActiveTab(index) }}>
                                            <Tab
                                                isActive={index == this.state.activeTab}
                                                name={tab.name}
                                                icon="ti-home"
                                            />
                                        </button>
                                    })
                                }
                            </ul>

                            <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                                {this.state.tabs[this.state.activeTab].content}
                                <div className="row align-items-center justify-content-center">
                                    <button
                                        onClick={this.return}
                                        className="col-auto btn btn-sm btn-light waves-effect waves-light"
                                    >
                                        Volver
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>


                }

            </div>
        );
    }
}
OrdenEdit.propTypes = {
    // Hooks props
    location: PropTypes.shape({
        state: PropTypes.object
    }),
    navigate: PropTypes.func,
    // Redux props
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    history: PropTypes.string,
    emptyFiltro: PropTypes.shape({
        ordenes: PropTypes.bool,
    }),
    orden: PropTypes.shape({
        idVendedorBoca: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        seller: PropTypes.shape({
            urlLogo: PropTypes.string,
        }),
        plataforma: PropTypes.shape({
            codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
    loadingOrdenes: PropTypes.bool,
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
    }),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Actions props
    fetchOrden: PropTypes.func,
    fetchMotivosRevision: PropTypes.func,
    limpiarFiltros: PropTypes.func,
}

const mapStateToProps = state => ({
    orden: state.ordenes.orden,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    emptyFiltro: state.general.limpiar,
    userType: state.general.userType,
    userId: state.general.userId
});

export default connect(mapStateToProps, {
    fetchOrden,
    fetchMotivosRevision,
    limpiarFiltros
})(OrdenEditWrapper);